import { ArtifactLogo } from "@/components/ui/artifact-logo";
import { Link, useLocation } from "react-router-dom";

export function AuthHeaderPortal() {
  const location = useLocation();
  const isOnboardingRoute = location.pathname.includes("/auth/onboarding");

  const logoContent = (
    <>
      <ArtifactLogo className="h-8 w-8 transition-transform group-hover:scale-105" />
      <span className="font-grotesk text-xxl font-semibold text-foreground/80 transition-colors group-hover:text-foreground">
        Artifact
      </span>
    </>
  );

  return (
    <div className="fixed left-0 top-0 z-50 w-full p-4">
      <div className="mx-auto max-w-7xl">
        {isOnboardingRoute ? (
          <div className="inline-flex items-center gap-2 rounded-lg p-2">
            {logoContent}
          </div>
        ) : (
          <Link
            to="/"
            className="group inline-flex items-center gap-2 rounded-lg p-2 transition-colors"
          >
            {logoContent}
          </Link>
        )}
      </div>
    </div>
  );
}

export default AuthHeaderPortal;
